<template>
  <div :class="$style['bill-items']">
    <div :class="$style['bill-item']" v-for="item in items" :key="item.id">
      <div :class="$style['container']">
        <div :class="$style['title']">
          <span v-color="colorFontBody" v-font-style="fontBody">{{
            item.name
          }}</span>
        </div>
        <div :class="$style['price']">
          <span v-color="colorFontBody" v-font-style="fontBody"
            >£{{ item.price.toFixed(2) }}</span
          >
        </div>
      </div>
      <v-collapse
        expandText="View choices"
        collapseText="Hide choices"
        v-if="item.choices.length > 0"
        v-color="colorFontBody"
        v-font-style="fontBody"
      >
        <div
          :class="$style['item']"
          v-for="choice in item.choices"
          :key="choice.id"
        >
          <span v-color="colorFontBody" v-font-style="fontBody">{{
            choice.name
          }}</span>
          <span
            :class="$style['price']"
            v-if="choice.price"
            v-color="colorFontBody"
            v-font-style="fontBody"
            >£{{ choice.price.toFixed(2) }}</span
          >
        </div>
      </v-collapse>
    </div>
  </div>
</template>

<script>
const VCollapse = () => import('@components/v-collapse.vue')

export default {
  components: {
    VCollapse,
  },
  props: {
    colorFontBody: {
      type: String,
      default: '',
    },
    fontBody: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.bill-items {
  padding-top: 34px;
}

.bill-item {
  display: flex;
  flex-direction: column;
  position: relative;

  .container {
    display: flex;
    justify-content: space-between;
  }

  span {
    // color: #2f2f2f;
    font-size: 14px;
    line-height: 1.8;
    text-align: left;
  }

  .title {
    align-content: flex-start;
    display: flex;
    flex-direction: column;
  }

  .item {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &:after {
    // background-color: $very-light-pink;
    bottom: 0;
    content: '';
    height: 1px;
    position: absolute;
    width: 100%;
  }

  &:last-child {
    &:after {
      height: 0;
    }
  }
}
</style>
